import relatorioGeralSaidaPaciente from './relatorioGeralSaidaPaciente'

export default [
    {
        path: 'relatorios',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...relatorioGeralSaidaPaciente,
        ]
    }
]
